import React from 'react'
import './about.css';
import Timeline from './timeline';

export default function About() {

  return (
    <section id='About'>
        <div className='about-content'>
            <div className='about-title'>
                Experiences
            </div>
            <div className='about-main'>
               <Timeline/>
            </div>
        </div>
    </section>
  )
}
